import { get, post, put, destroy } from '@/api/request';

function fetchPtoAvailabilities({ userId, params }) {
  return get(`/users/${userId}/pto_availabilities`, params);
}

function createPtoAvailability(data) {
  return post('/pto_availabilities', data);
}

function updatePtoAvailability(data) {
  return put('/pto_availabilities', data);
}

function deletePtoAvailability(id) {
  return destroy(`/pto_availabilities/${id}`);
}

function deletePtoAvailabilities({ userId, year, params }) {
  return get(`/users/${userId}/pto_availabilities/${year}`, params);
}

export default {
  fetchPtoAvailabilities,
  createPtoAvailability,
  updatePtoAvailability,
  deletePtoAvailability,
  deletePtoAvailabilities,
};



// WEBPACK FOOTER //
// ./src/store/modules/ptoAvailability/api.js